import React, { useState } from "react";
import { AccordionContainer } from "../../../../common/components/accordion/accordion.module";
import { InputContainer } from "../../../../common/components/form/input/containers/input.container";

export default function GlobalDbnBluePrintRegistriesServiceCategoryGroups({ GlobalDbnServiceCategory,
    handleInnerFormChange, handleDeleteGroup,
    subselectedCategor, handleAddGroup, selectedGroups, handleSelectedGroups,selectedCategory
}: any) {
    return (
        <>
            <AccordionContainer
                headerTitle={`Service Category Groups (${selectedGroups.length})`}
                expandedPanel="userInfo"
                child={
                    <div className="space-y-5">

                        {selectedGroups.length === 0 && (
                            <div className="border border-yellow-300 bg-yellow-50 rounded-lg p-4 text-yellow-700">
                                No Service Category Groups attached —
                                this release will not generate SCG entitlements
                                for tenants on save.
                            </div>
                        )}

                        {/* Add Service Category Group */}
                        <div className="space-y-3">
                            <p className="font-medium text-sm text-gray-700">
                                ADD SERVICE CATEGORY GROUP
                            </p>

                            <div className="grid md:grid-cols-3 gap-4 items-end">
                                <div className="md:col-span-2">
                                    <InputContainer
                                        label="Select Group"
                                        labelField="Name"
                                        list={GlobalDbnServiceCategory}
                                        type="select"
                                         isDisabled={!!selectedCategory?.GlobalBluePrintRegistryId}
                                        optionName="Select a group"
                                        value={selectedGroups?.GlobalDBNServiceCategoryGroupId}
                                        valueField="GlobalDBNServiceCategoryGroupId"
                                        onValueChange={(event: any) => {
                                            const selected = GlobalDbnServiceCategory.find(
                                                (item: any) =>
                                                    item.GlobalDBNServiceCategoryGroupId === Number(event.target.value)
                                            );

                                            handleSelectedGroups(selected);
                                        }}
                                    />
                                </div>

                                <button
                                    type="button"
                                    onClick={handleAddGroup}
                                    className="bg-blue-500 text-white px-4 py-3 rounded font-medium"
                                >
                                    + Add
                                </button>
                            </div>
                        </div>

                        {selectedGroups.length > 0 && (
                            <div className="space-y-3">
                                {selectedGroups.map((group, index) => (
                                    <div
                                        key={group.Id}
                                        className="border rounded-lg p-4 flex justify-between items-center"
                                    >
                                        <div>
                                            <p className="font-medium">
                                                {index + 1}. {group.Name}
                                            </p>
                                        </div>

                                        <button
                                            type="button"
                                            disabled={!!selectedCategory?.GlobalBluePrintRegistryId}
                                            onClick={() =>
                                                handleDeleteGroup(group.Id)
                                            }
                                            className="text-red-500 text-sm"
                                        >
                                            Remove
                                        </button>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                }
            />
        </>
    );
}